import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { bulkUpsertInventory, queryInventory } from '~/services/LuxLoyalty';

import { rewardsQueryKeys } from './rewardsQueryKeys';

/**
 * Fetches inventory rows for a catalog entry.
 * Pass `null` to disable the query (e.g. before an entry is selected).
 */
export function useGetRewardsInventory(catalogEntryId: string | null) {
  return useQuery({
    queryKey: catalogEntryId
      ? rewardsQueryKeys.inventoryByEntry(catalogEntryId)
      : [...rewardsQueryKeys.inventory(), 'disabled'],
    queryFn: async () => {
      if (!catalogEntryId) {
        return [];
      }
      return await queryInventory({ catalogEntryId });
    },
    enabled: Boolean(catalogEntryId),
  });
}

/** Bulk upserts inventory tiers for a catalog entry and invalidates the cache. */
export function useUpsertRewardsInventory() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: bulkUpsertInventory,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: rewardsQueryKeys.inventory() });
    },
  });
}
